<template>
  <div
    class="media pointer"
    @click.prevent="$router.push({name: 'conversation', params:{id: conversationId}})"
  >
    <div class="media-body">
      <h6 class="mt-0">
        <span :class="{'text-secondary':notification.status>0}">
          <strong>#{{ notification.request.requestType }}{{ buildLongId(notification.request.id) }} </strong>
        </span>
        <small class="pull-right">
          {{ getMoment(notification.logTime)}}
        </small>
      </h6>
      <p class="mb-0">
        {{ $t('yeniMzakirBaladld') }}
      </p>
    </div>
  </div>
</template>
<script>
import {buildLongId} from "@/repositories/Utils";
import moment from "moment/moment";

export default {
  name: 'NotificationConversationStarted',
  props: {
    notification: {
      type: Object,
      default(){
        return null;
      }
    }
  },

  computed:{
    conversationId(){

      if(this.notification?.data){
        return JSON.parse(this.notification.data).conversationId;
      }

      return 0;

    }
  },
  methods:{
    getMoment(time){
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY')
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
  }
}
</script>
